import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { AIAssistants } from './aiAssistants/AIAssistants';
import { Personalization } from './personalization/Personalization';
import { QuickVideos } from './quickVideos/QuickVideos';
import { NotFoundTemplate } from '../notFound';
import { UpsertQuickVideoModal } from './quickVideos/modals/UpsertQuickVideoModal';
import { TestSendModal } from './quickVideos/modals/TestSendModal';

export const AIConfigurationRoutes = () => {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Redirect to={`${url}/ai-assistants`} />
      </Route>

      <Route
        path={`${path}/ai-assistants`}
        exact
        render={() => <AIAssistants />}
      />
      <Route
        path={`${path}/personalization`}
        exact
        render={() => <Personalization />}
      />
      <Route
        path={`${path}/quick-videos`}
        exact
        render={() => <QuickVideos />}
      />
      <Route
        path={`${path}/quick-videos/new`}
        component={UpsertQuickVideoModal}
        exact={true}
      />
      <Route
        path={`${path}/quick-videos/:quickVideoId`}
        component={UpsertQuickVideoModal}
        exact={true}
      />

      <Route
        path={`${path}/quick-videos/:quickVideoId/test-send`}
        component={TestSendModal}
        exact
      />

      <Route path='*' component={NotFoundTemplate} />
    </Switch>
  );
};
